import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { FaTimes, FaEdit, FaToggleOn, FaToggleOff, FaTrash } from 'react-icons/fa'
import { Modal } from '../../../../UI'
import { toggleRiderStatus, deleteRider } from '../../../../store/actions/riders'
import RiderForm from '../RiderForm'
import Container from './styles'

const RiderDetails = ({ show, handleClose, rider }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('overview')
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [showEditForm, setShowEditForm] = useState(false)

  if (!rider) return null

  const handleToggleStatus = async () => {
    // Use assignmentId for toggling status
    await dispatch(toggleRiderStatus(rider.assignmentId || rider.id))
  }

  const handleDelete = async () => {
    // Use assignmentId for deleting (removes company assignment)
    const result = await dispatch(deleteRider(rider.assignmentId || rider.id))
    if (result.success) {
      handleClose()
      navigate('/company/dashboard/riders')
    }
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A'
    return new Date(timestamp).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  return (
    <Modal showModal={show} onClose={handleClose} showCloseBtn={false}>
      <Container>
        <div className="rider-details--container">
          <header>
            <h2>Rider Details</h2>
            <button className="close--btn" onClick={handleClose}>
              <FaTimes />
            </button>
          </header>

          <div className="tabs--container">
            <button
              className={`tab ${activeTab === 'overview' ? 'active' : ''}`}
              onClick={() => setActiveTab('overview')}
            >
              Overview
            </button>
            <button
              className={`tab ${activeTab === 'actions' ? 'active' : ''}`}
              onClick={() => setActiveTab('actions')}
            >
              Actions
            </button>
          </div>

          <div className="details--content">
            {activeTab === 'overview' ? (
              <div className="tab-content">
                <div className="detail--row">
                  <label>Full Name</label>
                  <p>{rider.fullName || `${rider.firstName} ${rider.lastName}`}</p>
                </div>

                <div className="detail--row">
                  <label>Email</label>
                  <p>{rider.email}</p>
                </div>

                <div className="detail--row">
                  <label>Phone</label>
                  <p>{rider.phone}</p>
                </div>

                <div className="detail--row">
                  <label>Vehicle Type</label>
                  <p>{rider.vehicleType}</p>
                </div>

                <div className="detail--row">
                  <label>Vehicle Number</label>
                  <p>{rider.vehicleNumber}</p>
                </div>

                <div className="detail--row">
                  <label>Status</label>
                  <p className={`status ${rider.status?.toLowerCase()}`}>
                    {rider.status}
                  </p>
                </div>

                <div className="detail--row">
                  <label>Date Added</label>
                  <p>{formatDate(rider.createdAt)}</p>
                </div>

                <div className="detail--row">
                  <label>Last Updated</label>
                  <p>{formatDate(rider.updatedAt)}</p>
                </div>
              </div>
            ) : (
              <div className="tab-content actions-tab">
                <div className="action--card">
                  <div className="action--info">
                    <h4>Edit Rider</h4>
                    <p>Update rider information and vehicle details</p>
                  </div>
                  <button className="btn-edit" onClick={() => setShowEditForm(true)}>
                    <FaEdit />
                    Edit
                  </button>
                </div>

                <div className="action--card">
                  <div className="action--info">
                    <h4>Toggle Status</h4>
                    <p>
                      Current status: <strong>{rider.status}</strong>
                    </p>
                  </div>
                  <button className="btn-status" onClick={handleToggleStatus}>
                    {rider.status === 'ACTIVE' ? <FaToggleOff /> : <FaToggleOn />}
                    {rider.status === 'ACTIVE' ? 'Deactivate' : 'Activate'}
                  </button>
                </div>

                <div className="action--card danger">
                  <div className="action--info">
                    <h4>Remove Rider</h4>
                    <p>Remove this rider's access to your company</p>
                  </div>
                  <button
                    className="btn-delete"
                    onClick={() => setShowDeleteConfirm(true)}
                  >
                    <FaTrash />
                    Remove
                  </button>
                </div>

                {showDeleteConfirm && (
                  <div className="delete-confirm">
                    <p>Are you sure you want to remove this rider from your company?</p>
                    <p className="warning">
                      This will remove their access to your company's orders. 
                      Their account will remain active and they can be re-assigned later.
                    </p>
                    <div className="confirm-actions">
                      <button
                        className="btn-cancel"
                        onClick={() => setShowDeleteConfirm(false)}
                      >
                        Cancel
                      </button>
                      <button className="btn-confirm-delete" onClick={handleDelete}>
                        Yes, Remove
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {showEditForm && (
          <RiderForm 
            show={showEditForm} 
            handleClose={() => {
              setShowEditForm(false)
              handleClose()
            }} 
            editData={rider}
          />
        )}
      </Container>
    </Modal>
  )
}

export default RiderDetails
